import { Box, Divider, styled, Typography } from '@mui/material';
import Button from '../components/Button';
import DrivioLogo from '../components/DrivioLogo';

const ACCOUNT_DELETE_URL =
  'mailto:support@driviovtc.fr?subject=Demande%20de%20suppression%20de%20compte';

const DATA_DELETE_URL =
  'mailto:support@driviovtc.fr?subject=Demande%20de%20suppression%20de%20données';

const PageWrapper = styled(Box)({
  minHeight: '100vh',
  backgroundColor: '#101216',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 24,
  boxSizing: 'border-box',
});

const Card = styled(Box)({
  width: '100%',
  maxWidth: 520,
  backgroundColor: '#1B1D22',
  borderRadius: 20,
  padding: '56px 40px',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 32,
});

const OptionBox = styled(Box)({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 12,
});

const buttonSx = {
  backgroundColor: '#B9FF66',
  color: '#0C1016',
  '&:hover': { backgroundColor: '#A7EB58' },
};

const DataDeleteScreen = () => (
  <PageWrapper>
    <Card>
      <DrivioLogo sx={{ fontSize: 24 }} />

      <Typography
        variant="h5"
        sx={{ fontWeight: 700, color: '#FFFFFF', textAlign: 'center', letterSpacing: 0.06 }}
      >
        Suppression de compte et de données
      </Typography>

      <Typography variant="body2" sx={{ color: '#9B9FA8', textAlign: 'center', lineHeight: 1.6 }}>
        Vous pouvez demander la suppression de votre compte uniquement, ou la suppression de
        l'ensemble de vos données personnelles. Choisissez l'option souhaitée ci-dessous.
      </Typography>

      <OptionBox>
        <Typography variant="subtitle2" sx={{ color: '#FFFFFF', fontWeight: 700 }}>
          Suppression du compte
        </Typography>
        <Typography variant="body2" sx={{ color: '#9B9FA8', textAlign: 'center', lineHeight: 1.6 }}>
          Votre compte sera désactivé et supprimé. Certaines données peuvent être conservées
          conformément à nos obligations légales.
        </Typography>
        <Button
          component="a"
          href={ACCOUNT_DELETE_URL}
          variant="contained"
          disableElevation
          sx={buttonSx}
        >
          Supprimer mon compte
        </Button>
      </OptionBox>

      <Divider sx={{ width: '100%', borderColor: '#2C2F36' }} />

      <OptionBox>
        <Typography variant="subtitle2" sx={{ color: '#FFFFFF', fontWeight: 700 }}>
          Suppression des données personnelles
        </Typography>
        <Typography variant="body2" sx={{ color: '#9B9FA8', textAlign: 'center', lineHeight: 1.6 }}>
          Toutes vos données personnelles seront supprimées, y compris votre historique et vos
          informations de profil, sans suppression de votre compte.
        </Typography>
        <Button
          component="a"
          href={DATA_DELETE_URL}
          variant="contained"
          disableElevation
          sx={buttonSx}
        >
          Supprimer mes données
        </Button>
      </OptionBox>
    </Card>
  </PageWrapper>
);

export default DataDeleteScreen;
